<template>
  <div class="flat-icons">
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'left')"
      class="button flaticon-keyboard54"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="left"
    />
    <span
      :class="['button', {'flaticon-pause44': isPlay}, {'flaticon-play106': !isPlay}]"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="playOrPause"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'right')"
      class="button flaticon-keyboard53"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="right"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'up')"
      class="button flaticon-expand39"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="up"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'down')"
      class="button flaticon-expand38"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="down"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomin')"
      class="button flaticon-round57"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="zoomIn"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomout')"
      class="button flaticon-round56"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="zoomOut"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'fullscreen')"
      class="button flaticon-move26"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="fullScreen"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'info')"
      class="button flaticon-round52"
      :style="{'--color': spinControlIconsColor, '--size': size + 'px'}"
      @click="info"
    />
    <SpinInfo
      v-if="infoStatus"
      :text="infoText"
    />
  </div>
</template>

<script>
import { spinButtonControlMixin } from '@/mixins/spinButtonControl.mixin'
import SpinInfo from '@/widgets/common/SpinInfo'
import {mapGetters} from "vuex";
export default {
  name: "SpinFlaticonButtons",
  components: {
    SpinInfo
  },
  mixins: [spinButtonControlMixin],
  computed: {
    ...mapGetters({
      spinControlIconsColor: 'spinControl/spinControlIconsColor',
      size: 'spinControl/size'
    })
  }
}
</script>

<style lang="scss" scoped>
@import url('https://demo.sirv.com/sirv-controls/sirv-controls.css');
.flat-icons {
  width: 100%;
  min-height: 80px;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  span {
    display: flex;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .button {
    &::before {
      margin-left: 0;
      font-size: var(--size);
      color: var(--color);
    }
  }
}
</style>
